import React from 'react';
import { BarChart3, TrendingUp, Clock } from 'lucide-react';

const features = [
  {
    icon: BarChart3,
    title: 'Best Analysis',
    description: 'AI-assisted summaries pull key insights from market news. Clear headlines, subtitles, and bullet points.',
    gradient: 'from-primary to-primary-dark',
  },
  {
    icon: TrendingUp,
    title: 'Market Growth',
    description: 'Track bull and bear trends across global markets. Multi-language support for Indian and international traders.',
    gradient: 'from-primary-dark to-secondary',
  },
  {
    icon: Clock,
    title: 'Real-time Updates',
    description: 'Auto-refreshing news feed every 30 minutes. Stay updated with "Just now" and "hours ago" time labels.',
    gradient: 'from-secondary to-primary',
  },
];

const FeaturesStrip = () => {
  return (
    <section className="relative mt-8 z-20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 rounded-2xl overflow-hidden shadow-xl">
          {features.map((feature, index) => (
            <div 
              key={feature.title}
              className={`p-8 text-center bg-gradient-to-br ${feature.gradient} ${
                index !== features.length - 1 ? 'md:border-r md:border-primary-foreground/10' : ''
              }`}
            >
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary-foreground/10 flex items-center justify-center">
                <feature.icon className="w-8 h-8 text-primary-foreground" />
              </div>
              <h3 className="text-xl font-semibold text-primary-foreground mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-primary-foreground/80 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesStrip;
